import client, { uploadFile, PaginatedResponse } from '@/utils/client'
import urls from '@/utils/urls'

const LIKE = 1
const DISLIKE = -1

var defaultState = {}

export const liveEventVisibilities = {
  draft: 'Draft (visible only to you)',
  private: 'Private (only invited fans may participate)',
  public: 'Public (available to everyone)'
}

export const liveEventChatTypes = {
  fan2fan: 'All comments are visible to everyone',
  fan2artist: 'Fans\' comments are only visible to you',
  disabled: 'Chat is disabled'
}

export const mutations = {
}

export const getters = {
}

export const actions = {
  listOwnLiveEvents (ctx, filter) {
    return client.get(urls.live.publish.list(), {
      params: filter
    }).then(response => new PaginatedResponse(response.data))
  },
  createLiveEvent (ctx, data) {
    if (data.id) throw new Error('live event id is defined, can\'t create anew')
    return client.post(urls.live.publish.list(), data).then(response => response.data)
  },
  updateLiveEvent (ctx, data) {
    if (!data.id) throw new Error('live event id undefined, can\'t update event')
    return client.patch(urls.live.publish.detail(data.id), data).then(response => response.data)
  },
  deleteLiveEvent (ctx, {id}) {
    return client.delete(urls.live.publish.detail(id)).then(response => response.data)
  },
  getOwnLiveEvent (ctx, {id}) {
    return client.get(urls.live.publish.detail(id)).then(response => response.data)
  },
  async setLiveEventPromo ({dispatch}, {id, file}) {
    await uploadFile(urls.live.publish.promo(id), file)
    return dispatch('getOwnLiveEvent', {id})
  },
  async deleteLiveEventPromo ({dispatch}, {id}) {
    let response = await client.delete(urls.live.publish.promo(id))
    return response.data
  },
  startLiveEvent (ctx, {id}) {
    return client.post(urls.live.publish.start(id)).then(response => response.data)
  },
  stopLiveEvent (ctx, {id}) {
    return client.post(urls.live.publish.stop(id)).then(response => response.data)
  },
  cancelLiveEvent (ctx, {id}) {
    return client.patch(urls.live.publish.detail(id), {is_cancelled: true}).then(response => response.data)
  },
  async blockUser (ctx, {eventId, profileId}) {
    return client.post(urls.live.publish.block_user(eventId), {profile_id: profileId})
  },
  listLiveEvents (ctx, filter) {
    if (filter.is_cancelled !== undefined) {
      filter.is_cancelled = (filter.is_cancelled) ? 1 : 0
    }

    return client
      .get(urls.live.consume.list(), {
        params: filter
      })
      .then(response => new PaginatedResponse(response.data))
  },
  getLiveEvent (ctx, {id}) {
    return client.get(urls.live.consume.detail(id)).then(response => response.data)
  },
  bookLiveEvent (ctx, {id, amount}) {
    var params = amount ? {amount: amount} : undefined
    return client.post(urls.live.consume.book(id), params).then(response => response.data)
  },
  async addToWatchlist ({dispatch}, {id}) {
    await client.post(urls.live.consume.watch(id))
    await dispatch('profile/getCurrentUser', null, { root: true })
  },
  async removeFromWatchlist ({dispatch}, {id}) {
    await client.delete(urls.live.consume.watch(id))
    await dispatch('profile/getCurrentUser', null, { root: true })
  },
  attendLiveEvent (ctx, {id}) {
    return client.get(urls.live.consume.attend(id)).then(response => response.data)
  },
  async pingLiveEvent (ctx, {id}) {
    try {
      const response = await client.post(urls.live.consume.ping(id))
      return response.data
    } catch (e) {
      if (e && e.response && (e.response.status === 410)) {
        return e.response.data
      } else {
        return null
      }
    }
  },
  likeLiveEvent (ctx, {id}) {
    return client.post(urls.live.consume.rate(id), {rating: LIKE}).then(response => response.data)
  },
  dislikeLiveEvent (ctx, {id}) {
    return client.post(urls.live.consume.rate(id), {rating: DISLIKE}).then(response => response.data)
  },
  unlikeLiveEvent (ctx, {id}) {
    return client.delete(urls.live.consume.rate(id)).then(response => response.data)
  },
  getLiveEventComments (ctx, {id}) {
    return client.get(urls.live.consume.commentList(id)).then(response => new PaginatedResponse(response.data))
  },
  postLiveEventComment (ctx, {id, text, asArtist = false}) {
    return client
      .post(urls.live.consume.commentList(id), {text, as_artist: asArtist})
      .then(response => response.data)
  },
  deleteLiveEventComment (ctx, {eventId, commentId}) {
    return client
      .delete(urls.live.consume.commentDetail(eventId, commentId))
      .then(response => response.data)
  },
  async getMessages (ctx, {id}) {
    let response = await client.get(urls.live.consume.messages(id))
    return response.data
  },
  async sendMessage (ctx, {id, message}) {
    return client.post(urls.live.consume.send_message(id), {message: message})
  },
  async deleteMessage (ctx, {eventId, senderId, time}) {
    return client.post(urls.live.consume.delete_message(eventId), {sender_id: senderId, time: time})
  },
  async listTickets (ctx) {
    const response = await client.get(urls.live.tickets.list())
    return new PaginatedResponse(response.data)
  },
  async reportLiveEvent ({ dispatch }, { id, reason, url }) {
    return client.post(urls.live.consume.report(id), { reason, url })
  },
  async reportLiveEventComment ({ dispatch }, { subjectId, commentId, reason, url }) {
    return client.post(urls.live.consume.reportComment(subjectId, commentId), { reason, url })
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/live.js